import type { ComponentProps, ReactNode } from "react";

import { MarketingNav } from "./MarketingNav";
import { Footer } from "../sections/Footer";

type Current = ComponentProps<typeof MarketingNav>["current"];

export function MarketingPageLayout({
  children,
  current,
}: {
  children: ReactNode;
  current?: Current;
}) {
  return (
    <div className="min-h-screen bg-[#FDFDFF]">
      <MarketingNav current={current} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
